
import axios from "axios";
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      pedido: null,
      clienteId: null,
      tipoSituacao: ['0','1','2','3','4','5','6'],
      registroSelecionadoId: null,
      paginaAtual: 1,
      perPage: 100,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    PEDIDO: state => {
        return state.pedido
    },
    TIPO_SITUACAO: state => {
        return state.tipoSituacao
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_PEDIDO: (state, payload) => {
          state.pedido = payload
      },
      SET_TIPO_SITUACAO: (state, payload) => {
          state.tipoSituacao = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.pedido = null
        state.clienteId = null
        state.tipoSituacao = ''
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = getters.ID ? `&id=${getters.ID}` : ''
          let clienteId = getters.CLIENTE_ID ? `&clienteId=${getters.CLIENTE_ID}` : ''
          let pedido = getters.PEDIDO ? `&pedido=${getters.PEDIDO}` : ''
          let tipoSituacao = getters.TIPO_SITUACAO ? `&situacao=${getters.TIPO_SITUACAO}` : ''
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '01/01/2000')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '01/01/2000')
          let servico = `&servico=2`

          let uri = `/api/protected/vendapedido/pesquisarweb?opPedido=2&dt1=${dt1}&dt2=${dt2}${id}${pedido}${tipoSituacao}${clienteId}${servico}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              if (!skipConfirmation && data.length > LIMITE_REGISTROS_PESQUISA) {
                resolve({ data, status, needsConfirmation: true, count: data.length });
                return;
              }
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {

                //ajustar a lista de pesquisa com as maskaras
                for (let i = 0; i < data.length; i++) {
                    if (!!data[i].PERCENTUAL) {
                        data[i].PERCENTUAL   = data[i].PERCENTUAL.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 2})
                    } else {
                        data[i].PERCENTUAL = 0.00
                    }
                    if (!!data[i].DT_SAIDA) {
                        data[i].DT_SAIDA     = new Date(data[i].DT_SAIDA).toISOString().substr(0, 10).split('-').reverse().join('/')
                    }
                    if (!!data[i].VENCIMENTO) {
                    data[i].VENCIMENTO = new Date(data[i].VENCIMENTO).toISOString().substr(0, 10).split('-').reverse().join('/')
                    } else {
                    data[i].VENCIMENTO = null
                    }
                }
                
                resolve({ data, status, needsConfirmation: false });
              }
            })
            .catch(erro => {
                reject(erro)
            })
        });
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/retirada-servico-estore.js